import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

import SalesAbout from 'assets/images/photos/SalesAbout.jpg';

const PrivacyDetails = () => {
    return (
        <section className="py-5 mb-xl-5 mb-lg-4 position-relative" data-aos="fade-up">
            <Container>
                <div className="w-full min-h-screen bg-gray-100 flex justify-center p-3">
                    <div className="bg-white shadow-xl rounded-2xl p-6 max-w-4xl text-gray-800 leading-relaxed overflow-auto">

                        {/* MAIN HEADER */}
                        <h2 style={{ fontSize: "22px", fontWeight: "bold", marginBottom: "16px" }}>
                            Privacy Policy
                        </h2>

                        {/* Platform + Date */}
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                            <p style={{ fontSize: "16px" }}><strong>Platform:</strong> SalesTrackify</p>
                            <p style={{ fontSize: "16px" }}><strong>Last updated:</strong> 10-12-2025</p>
                        </div>

                        {/* Paragraph */}
                        <p style={{ fontSize: "16px", marginTop: "16px" }}>
                            This Privacy Policy explains how we collect, use, disclose, and protect your personal data when you use the SalesTrackify CRM platform (“Service”). It is intended to comply with the UK General Data Protection Regulation (“UK GDPR”) and the Data Protection Act 2018.
                        </p>

                        {/* SECTION 1 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>1. Who We Are</h2>

                        <p style={{ fontSize: "16px" }}>For the purposes of UK data protection law, the data controller is:</p>
                        <p style={{ fontSize: "16px" }}>
                            CoreScripts Technologies LTD<br />
                            Rugby, UK<br />
                            Email: <a href="hello@salestrackify.com" className="text-primary underline">hello@salestrackify.com</a><br />
                            Website: <a href="https://salestrackify.com" className="text-primary underline">https://salestrackify.com</a>
                        </p>

                        {/* SECTION 2 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>2. Scope of This Policy</h2>

                        <p style={{ fontSize: "16px" }}>This Policy applies to:</p>
                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>
                                Visitors to our website at <a href="https://salestrackify.com" className="text-primary underline">salestrackify.com</a>
                            </li>
                            <li style={{ fontSize: "16px" }}>Users of the SalesTrackify CRM platform;</li>
                            <li style={{ fontSize: "16px" }}>Individuals whose personal data is processed by our customers.</li>
                        </ul>

                        <p style={{ fontSize: "16px" }}>
                            Where we process personal data on behalf of a customer, we act as a data processor and our customer acts as the data controller.
                        </p>

                        {/* SECTION 3 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>3. Personal Data We Collect</h2>

                        <h3 style={{ fontSize: "18px", fontWeight: "500", marginTop: "16px", marginBottom: "4px" }}>3.1 Data You Provide to Us</h3>

                        <p style={{ fontSize: "16px" }}>We may collect the following information:</p>
                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>Full name and contact details;</li>
                            <li style={{ fontSize: "16px" }}>Company name and business details;</li>
                            <li style={{ fontSize: "16px" }}>Account login details;</li>
                            <li style={{ fontSize: "16px" }}>Billing information;</li>
                            <li style={{ fontSize: "16px" }}>Any messages or emails you send us.</li>
                        </ul>

                        <h3 style={{ fontSize: "18px", fontWeight: "500", marginTop: "16px", marginBottom: "4px" }}>3.2 Data We Collect Automatically</h3>

                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>IP address and approximate location;</li>
                            <li style={{ fontSize: "16px" }}>Browser type, device type;</li>
                            <li style={{ fontSize: "16px" }}>Pages visited and usage behavior;</li>
                            <li style={{ fontSize: "16px" }}>Performance and crash logs.</li>
                        </ul>

                        <h3 style={{ fontSize: "18px", fontWeight: "500", marginTop: "16px", marginBottom: "4px" }}>3.3 Customer Data within the CRM</h3>

                        <p style={{ fontSize: "16px" }}>Customer data may include:</p>
                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>Names, emails, phone numbers;</li>
                            <li style={{ fontSize: "16px" }}>Business information;</li>
                            <li style={{ fontSize: "16px" }}>Notes, tasks, deals, communication logs.</li>
                        </ul>

                        <p style={{ fontSize: "16px" }}>
                            In this case, our customer acts as the data controller and we act as the data processor.
                        </p>

                        {/* SECTION 4 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>4. Legal Bases for Processing (UK GDPR)</h2>

                        <p style={{ fontSize: "16px" }}>We rely on the following legal bases:</p>
                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}><strong>Contractual necessity</strong> – to provide the Service.</li>
                            <li style={{ fontSize: "16px" }}><strong>Legitimate interests</strong> – to improve and secure services.</li>
                            <li style={{ fontSize: "16px" }}><strong>Legal obligation</strong> – compliance with laws.</li>
                            <li style={{ fontSize: "16px" }}><strong>Consent</strong> – where you have agreed for specific processing.</li>
                        </ul>

                        {/* SECTION 5 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>5. How We Use Your Personal Data</h2>

                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>Provide and operate the Service;</li>
                            <li style={{ fontSize: "16px" }}>Manage user accounts;</li>
                            <li style={{ fontSize: "16px" }}>Billing and payment processing;</li>
                            <li style={{ fontSize: "16px" }}>Customer support;</li>
                            <li style={{ fontSize: "16px" }}>Analytics and improvements;</li>
                            <li style={{ fontSize: "16px" }}>Marketing communications (where allowed);</li>
                            <li style={{ fontSize: "16px" }}>Compliance with legal obligations.</li>
                        </ul>

                        {/* SECTION 6 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>6. Cookies and Similar Technologies</h2>

                        <p style={{ fontSize: "16px" }}>We use cookies to:</p>
                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>Keep you signed in;</li>
                            <li style={{ fontSize: "16px" }}>Remember preferences;</li>
                            <li style={{ fontSize: "16px" }}>Gather analytics;</li>
                            <li style={{ fontSize: "16px" }}>Enable platform features.</li>
                        </ul>

                        <p style={{ fontSize: "16px" }}>
                            You may disable cookies via your browser settings, but some features may stop working.
                        </p>

                        {/* SECTION 7 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>7. Sharing Your Personal Data</h2>

                        <p style={{ fontSize: "16px" }}>We may share data with:</p>
                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>Service providers (hosting, email, payment);</li>
                            <li style={{ fontSize: "16px" }}>Professional advisors;</li>
                            <li style={{ fontSize: "16px" }}>Regulatory authorities if legally required.</li>
                        </ul>

                        <p style={{ fontSize: "16px" }}>We do NOT sell or rent personal data.</p>

                        {/* SECTION 8 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>8. International Data Transfers</h2>

                        <p style={{ fontSize: "16px" }}>
                            Your data may be stored in the UK or other countries. When transferring internationally, we ensure:
                        </p>

                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>IDTA agreements;</li>
                            <li style={{ fontSize: "16px" }}>UK Addendum to EU SCCs;</li>
                            <li style={{ fontSize: "16px" }}>Adequacy decisions.</li>
                        </ul>

                        {/* SECTION 9 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>9. Data Retention</h2>

                        <p style={{ fontSize: "16px" }}>
                            We retain personal data as long as needed, including for legal and reporting requirements.
                        </p>
                        <p style={{ fontSize: "16px" }}>
                            Customer CRM data may be retained 30–90 days after account closure.
                        </p>

                        {/* SECTION 10 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>10. Your Rights Under UK Law</h2>

                        <p style={{ fontSize: "16px" }}>You have the right to:</p>

                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>Access your data;</li>
                            <li style={{ fontSize: "16px" }}>Rectify inaccurate data;</li>
                            <li style={{ fontSize: "16px" }}>Request deletion;</li>
                            <li style={{ fontSize: "16px" }}>Restrict processing;</li>
                            <li style={{ fontSize: "16px" }}>Data portability;</li>
                            <li style={{ fontSize: "16px" }}>Object to processing;</li>
                            <li style={{ fontSize: "16px" }}>Avoid automated decisions.</li>
                        </ul>

                        <p style={{ fontSize: "16px" }}>
                            To exercise rights, contact:
                            <a href="mailto:hello@salestrackify.com" className="text-primary underline"> hello@salestrackify.com</a>
                        </p>

                        {/* SECTION 11 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>11. Marketing Communications</h2>

                        <p style={{ fontSize: "16px" }}>
                            You may receive marketing messages if you requested info or purchased services.
                        </p>

                        <p style={{ fontSize: "16px" }}>You can stop emails by:</p>
                        <ul className="list-disc ml-6">
                            <li style={{ fontSize: "16px" }}>Unsubscribe link in email;</li>
                            <li style={{ fontSize: "16px" }}>Contacting





                                <p style={{ fontSize: "16px" }}>

                                    <a href="mailto:hello@salestrackify.com" className="text-primary underline"> hello@salestrackify.com</a>
                                </p>
                            </li>
                        </ul>

                        {/* SECTION 12 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>12. Data Security</h2>

                        <p style={{ fontSize: "16px" }}>
                            We use appropriate technical and organisational measures. No method is 100% secure.
                        </p>

                        <p style={{ fontSize: "16px" }}>
                            Users are responsible for keeping login credentials secure.
                        </p>

                        {/* SECTION 13 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>13. Third-Party Links</h2>

                        <p style={{ fontSize: "16px" }}>
                            Third-party websites have their own privacy policies. We are not responsible for them.
                        </p>

                        {/* SECTION 14 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>14. Children’s Privacy</h2>

                        <p style={{ fontSize: "16px" }}>
                            The Service is not intended for users under 16. If a child provides data, contact us.
                        </p>

                        {/* SECTION 15 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>15. Changes to This Privacy Policy</h2>

                        <p style={{ fontSize: "16px" }}>
                            Updates may occur. “Last updated” date will be revised accordingly.
                        </p>

                        {/* SECTION 16 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>16. Contact Us</h2>

                        <p style={{ fontSize: "16px" }}>
                            <strong>CoreScripts Technologies LTD</strong><br />
                            Address: Rugby, UK <br />
                            Company Number(Reg): 14799652 <br />
                            Email: <a className="text-primary underline" href="mailto:hello@salestrackify.com">hello@salestrackify.com</a>
                        </p>

                        {/* SECTION 17 */}
                        <h2 style={{ fontSize: "22px", fontWeight: "600", marginTop: "24px", marginBottom: "8px" }}>17. Your Right to Complain</h2>

                        <p style={{ fontSize: "16px" }}>
                            You can file complaints with:
                        </p>

                        <p style={{ fontSize: "16px" }}>
                            Information Commissioner’s Office (ICO)<br />
                            Website: <a href="https://ico.org.uk" className="text-primary underline">https://ico.org.uk</a>
                        </p>
                    </div>
                </div>



            </Container>
        </section>
    );
};

export default PrivacyDetails;
